// extracted by mini-css-extract-plugin
module.exports = {"breadcrumpbs":"BreadCrumbs_breadcrumpbs_1cTMi","currentPage":"BreadCrumbs_currentPage_2bsUM","positionRelative":"BreadCrumbs_positionRelative_1KECQ"};